<div *ngIf="loading || suggestion" [class.loading]="loading" class="ai-suggestion-pill">
  <div
    [class.confidence-high]="confidenceLevel === 'high'"
    [class.confidence-low]="confidenceLevel === 'low'"
    [class.confidence-medium]="confidenceLevel === 'medium'"
    class="pill-content"
  >
    <ng-container *ngIf="loading">
      <astrobin-sparkles-icon [height]="14" [width]="14"></astrobin-sparkles-icon>
      <span class="pill-text">{{ "Analyzing… Select manually if you prefer" | translate }}</span>
      <span class="spinner-border spinner-border-sm ms-2" role="status">
        <span class="visually-hidden">{{ "Loading..." | translate }}</span>
      </span>
    </ng-container>

    <ng-container *ngIf="!loading && suggestion">
      <astrobin-sparkles-icon [height]="14" [width]="14"></astrobin-sparkles-icon>
      <span [ngbTooltip]="tooltipText" class="pill-text">
        {{ displayValue }}
        <span class="confidence-badge">({{ confidencePercentage }}%)</span>
      </span>
      <button
        [attr.aria-label]="'Apply suggestion' | translate"
        (click)="onApply()"
        class="btn btn-link btn-sm apply-btn"
        type="button"
      >
        {{ "Apply" | translate }}
      </button>
      <button
        [attr.aria-label]="'Dismiss suggestion' | translate"
        (click)="onDismiss()"
        class="btn btn-link btn-sm dismiss-btn"
        type="button"
      >
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
      </button>
    </ng-container>
  </div>
</div>
